import type { MechKey } from './keys';

export const ta: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'இயக்கவியல் · 2D',
  'panel.scene': 'காட்சி',
  'panel.dims': 'அளவுருக்கள்',
  'panel.style': 'தோற்றம்',
  'panel.action': 'கட்டுப்பாடுகள்',
  'style.body': 'உடல்',
  'style.vector': 'திசையன்கள்',
  'style.ground': 'தரை',
  'style.forces': 'விசைகளைக் காட்டு',
  'style.trace': 'தடத்தைக் காட்டு',
  'style.labels': 'திசையன் லேபல்கள்',
  'hint.line1': 'தொடங்க இயக்கு கிளிக் செய்யவும் · பொருட்களை இழுக்கவும்',
  'hint.line2': 'சாண்ட்பாக்ஸ்: ஒரு வடிவம் தேர்ந்தெடுக்கவும், பின் வைக்க கிளிக் செய்யவும்',
  'scene.incline': 'சாய்தளம்',
  'scene.projectile': 'எறிபொருள் இயக்கம்',
  'scene.pendulum': 'தொங்கலாட்டம்',
  'scene.springMass': 'சுருள்வில்-நிறை அமைப்பு',
  'scene.collisions': 'மோதல்கள்',
  'scene.atwood': 'அட்வுட் இயந்திரம்',
  'scene.circular': 'வட்ட இயக்கம்',
  'scene.sandbox': 'சாண்ட்பாக்ஸ்',
  'dim.angle': 'கோணம் (°)',
  'dim.friction': 'உராய்வு',
  'dim.mass': 'நிறை',
  'dim.massA': 'நிறை A',
  'dim.massB': 'நிறை B',
  'dim.velocity': 'திசைவேகம்',
  'dim.angleLaunch': 'ஏவுகோணம் (°)',
  'dim.gravity': 'ஈர்ப்பு',
  'dim.gravityX': 'ஈர்ப்பு x',
  'dim.gravityY': 'ஈர்ப்பு y',
  'dim.length': 'நீளம்',
  'dim.damping': 'தணிப்பு',
  'dim.spring': 'கடினத்தன்மை',
  'dim.restitution': 'மீட்டெடுப்பு',
  'dim.radius': 'ஆரம்',
  'dim.speed': 'வேகம்',
  'action.play': 'இயக்கு',
  'action.pause': 'இடைநிறுத்து',
  'action.step': 'படி',
  'action.reset': 'மீட்டமை',
  'action.speed': 'வேகம்',
  'action.clear': 'அழி',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'ஈர்ப்பு விசை',
  'forceName.normal': 'செங்குத்து விசை',
  'forceName.friction': 'உராய்வு விசை',
  'forceName.tension': 'இழுவிசை',
  'forceName.spring': 'சுருள்வில் விசை',
  'forceName.applied': 'பயன்படுத்திய விசை',
  'forceName.air': 'காற்று எதிர்ப்பு',
  'palette.box': 'பெட்டி',
  'palette.circle': 'பந்து',
  'palette.ramp': 'சாய்வு',
  'palette.ground': 'தரை',
  'palette.hint': 'ஒரு வடிவம் தேர்ந்தெடுக்கவும், பின் வைக்க கேன்வாஸ் கிளிக் செய்யவும்.',
  'panel.forces': 'காணப்பட்ட விசைகள்',
  'forces.empty': 'இன்னும் இல்லை — காட்சியை இயக்கவும்',
};
